module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-personen__page--wrapper"
  }, [_c('SplitLayout', {
    attrs: {
      "cols": 2,
      "sidebar_right_width": 'width:40%;'
    }
  }, [_c('div', {
    staticClass: "ksm-texte__modus-main",
    staticStyle: {
      "padding": "50px 10px"
    },
    attrs: {
      "slot": "main-content"
    },
    slot: "main-content"
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex-x-center"
  }, [_c('div', {
    staticClass: "ksm-sidebar__container",
    staticStyle: {
      "max-width": "600px"
    }
  }, [_c('div', {
    staticClass: "ksm-accordion__header",
    staticStyle: {
      "border-top-color": "transparent",
      "border-bottom": "2px solid rgb(162, 173, 186)"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex",
    staticStyle: {
      "align-items": "center",
      "margin-left": "10px"
    }
  }, [_vm._v("Biographie")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.personenText)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "slot": "sidebar-2"
    },
    slot: "sidebar-2"
  }, [(_vm.personenCollection2) ? _c('div', {
    staticClass: "ksm-sidebar__wrapper"
  }, [_c('div', {
    staticClass: "ksm-sidebar__container"
  }, [_c('div', {
    staticClass: "ksm-accordion__header",
    staticStyle: {
      "border-top-color": "transparent",
      "border-bottom": "2px solid rgb(162, 173, 186)"
    }
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex",
    staticStyle: {
      "align-items": "center",
      "margin-left": "10px"
    }
  }, [_vm._v("Personen")])]), _vm._v(" "), _c('div', {
    ref: "scrollElement",
    staticClass: "ksm-personen__list-container"
  }, [_c('div', {
    staticClass: "ksm-accordion__content"
  }, _vm._l((_vm.personenCollection2), function(p, i) {
    return _c('div', {
      key: 'p' + i,
      attrs: {
        "id": 'pers_' + p.lemmaID
      }
    }, [_c('div', {
      staticClass: "ksm-personen__title ksm-flex-y-center",
      class: _vm.selectedIdx === i ? '__active' : '',
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('div', {
      staticClass: "ksm-personen__content",
      on: {
        "click": function($event) {
          _vm.selectedIdx = i
        }
      }
    }, [_vm._v(_vm._s(p.content))]), _vm._v(" "), (p.text) ? _c('div', {
      staticClass: "ksm-personen__has",
      domProps: {
        "innerHTML": _vm._s(_vm.$_getSvg('id-card.svg'))
      },
      on: {
        "click": function($event) {
          _vm.selectedIdx = i
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(" (" + _vm._s(p.docIds.length) + ")")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "20px",
        "width": "20px"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.$_getIcon(_vm.personenExpandIdx.indexOf(p.lemmaID) > -1 ? 'arrow-down.svg' : 'arrow-right.svg'))
      },
      on: {
        "click": function($event) {
          return _vm.togglePersonItem(p.lemmaID)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ksm-accordion__body",
      class: _vm.personenExpandIdx.indexOf(p.lemmaID) > -1 ? '' : 'ksm-accordion__collapse',
      staticStyle: {
        "background-color": "transparent",
        "border-width": "0",
        "padding": "0 10px"
      }
    }, [_c('g-person-merz', {
      staticStyle: {
        "font-size": "10pt",
        "padding-left": "15px"
      },
      attrs: {
        "person": p
      }
    })], 1)])
  }), 0)])])]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b323313","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Personen.vue
// module id = 1973
// module chunks = 1